var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 text-center"},[_vm._v("Cerrando sesión…")])
}
var staticRenderFns = []

export { render, staticRenderFns }